import { Alert, Box } from '@mui/material';
import React from 'react';

export const InfoBanner = ({ message }: { message: string }) => {
  return (
    <Box component="span" m={1}>
      <Alert severity="info">{message}</Alert>
    </Box>
  );
};
